import { getAereosAll, getAereosAllClaveViaje, getAereosClaveViaje } from "../services/serviceViaje";
import { getItemsPagarGrupo, newCompraItem, newItemPagoGrupal } from "../services/comprasService";
import { catTipoCompra } from "../constant/catTipoCompra";
const dataInicial = {
    aereos: [],
    grupos: [],
    total: 0,
    pagina: 0,
    registroPagina: 10,
    exito: 0,
    grupo: {},
    calculo: {},
    grupoValido: true,
    moneda: {},
    plazasTotal: 0,
    claveViaje: "NA"
};

const GET_AEREOS_ALL = "GET_AEREOS_ALL"
const GET_AEREOS_BUSQUEDA_ALL = "GET_AEREOS_BUSQUEDA_ALL"
const GET_AEREOS_REGISTROS_PAGINA = "GET_AEREOS_REGISTROS_PAGINA"
const GET_AEREOS_PAGINA = "GET_AEREOS_PAGINA"
const POST_AEREOS_EXITO = "POST_AEREOS_EXITO"
const PUT_AEREOS_AUTORIZADO_EXITO = "PUT_AEREOS_AUTORIZADO_EXITO"
const GET_AEREOS_GRUPOS_CLAVE = "GET_AEREOS_GRUPOS_CLAVE"
const SELECT_AEREOS_GRUPO = "SELECT_AEREOS_GRUPO"
const GET_AEREOS_GRUPO_CALCULO = "GET_AEREOS_GRUPO_CALCULO"
const POST_AEREOS_NEW_ITEM = "POST_AEREOS_NEW_ITEM"
const GET_AEREOS_CLAVE_VIAJE = "GET_AEREOS_CLAVE_VIAJE"
const CLEAR_AEREOS_STATE = "CLEAR_AEREOS_STATE"

export default function aereosReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_AEREOS_GRUPO_CALCULO:
            return { ...state, calculo: action.payload.calculo }
        case SELECT_AEREOS_GRUPO:
            return { ...state, grupo: action.payload.grupo }
        case GET_AEREOS_GRUPOS_CLAVE:
            return { ...state, moneda: action.payload.moneda, grupoValido: action.payload.grupoValido, grupos: action.payload.grupos, grupo: action.payload.grupo }
        case GET_AEREOS_CLAVE_VIAJE:
            return {
                ...state,
                aereos: action.payload.aereos,
                total: action.payload.total,
                pagina: action.payload.pagina,
                registroPagina: action.payload.registroPagina,
                claveViaje: action.payload.claveViaje
            }
        case GET_AEREOS_PAGINA:
            return {
                ...state,
                aereos: action.payload.aereos,
                total: action.payload.total,
                pagina: action.payload.pagina,
            }
        case GET_AEREOS_REGISTROS_PAGINA:
            return {
                ...state,
                aereos: action.payload.aereos,
                total: action.payload.total,
                registroPagina: action.payload.registroPagina
            }
        case GET_AEREOS_BUSQUEDA_ALL:
            return {
                ...state,
                aereos: action.payload.aereos,
                total: action.payload.total,
                pagina: action.payload.pagina,
                registroPagina: action.payload.registroPagina
            }
        case POST_AEREOS_EXITO:
            return { ...state, exito: action.payload.exito }
        case POST_AEREOS_NEW_ITEM:
            return { ...state, exito: action.payload.exito }
        case PUT_AEREOS_AUTORIZADO_EXITO:
            return { ...state, exito: action.payload.exito }
        case GET_AEREOS_ALL:
            return {
                ...state,
                aereos: action.payload.aereos,
                total: action.payload.total
            };
        case CLEAR_AEREOS_STATE:
            return {
                ...state,
                aereos: action.payload.aereos
            }
        default:
            return state;
    }
}
export const generarAereoAction = ({ idTipoCompra, ClaveViaje, CostoUnitarioAdulto, CostoUnitarioMenor, CostoUnitarioInfante, IdMoneda }) => async (dispatch) => {
    return await newItemPagoGrupal({ idTipoCompra, ClaveViaje, CostoUnitarioAdulto, CostoUnitarioMenor, CostoUnitarioInfante, IdMoneda }).then(Response => {
        dispatch({
            type: POST_AEREOS_EXITO,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const generarCompraAereoAction = ({ idPaquete, idMoneda, idCuenta }) => async (dispatch) => {
    return await newCompraItem({ idTipoCompra: catTipoCompra.Aereo, idPaquete, idMoneda, idCuenta, MontoProveedor: 0 }).then(Response => {
        dispatch({
            type: POST_AEREOS_NEW_ITEM,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerGruposClaveViajeAction = ({ claveViaje }) => async (dispatch, getSate) => {
    return await getAereosClaveViaje({ ClaveViaje: claveViaje }).then(Response => {
        dispatch({
            type: GET_AEREOS_GRUPOS_CLAVE,
            payload: {
                claveViaje,
                grupos: Response.lViajeVompra,
                grupoValido: !Response.lViajeVompra.every(element => element?.Compra?.estatusCompra?.idEstatusCompra === 3),
                grupo: { ...Response, FechaViaje: Response.Fecha_Viaje, PlazaAereo: Response.totalCumplido, PlazaTotal: Response.totalPlazas, lViajeVompra: [] }
                , moneda: Response?.lViajeVompra[0]?.Meta?.Paquete?.MonedaProveedor
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerCalculoGruposClaveViajeAction = ({ claveViaje }) => async (dispatch, getSate) => {
    return await getItemsPagarGrupo({ idTpoCompra: 2, ClaveViaje: claveViaje }).then(Response => {
        dispatch({
            type: GET_AEREOS_GRUPO_CALCULO,
            payload: {
                calculo: Response,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const selectAereosGrupoAction = ({ grupo }) => async (dispatch, getSate) => {
    dispatch({
        type: SELECT_AEREOS_GRUPO,
        payload: {
            grupo: grupo,
        },
    })
}
// export const obtenerAereosBusquedaAction = ({ Referencia, EstatusCompra }) => async (dispatch, getSate) => {
//     return await getReservasAll({ Pagina: dataInicial.pagina + 1, Registros: dataInicial.registroPagina }).then(Response => {
//         dispatch({
//             type: GET_AEREOS_BUSQUEDA_ALL,
//             payload: {
//                 aereos: Response.listViajeCompra,
//                 total: Response.tamanio,
//                 pagina: dataInicial.pagina,
//                 registroPagina: dataInicial.registroPagina,
//             },
//         });
//         return Response
//     }).catch(Error => {
//         return {}
//     })
// }
export const obtenerAereosAction = () => async (dispatch, getSate) => {
    const { pagina, registroPagina, claveViaje } = getSate().aereos
    return await getAereosAllClaveViaje({ ClaveViaje: claveViaje, Pagina: pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_AEREOS_ALL,
            payload: {
                aereos: Response.listGrupoAereo,
                total: Response.tamanio
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerAereosRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { pagina, claveViaje } = getSate().aereos
    return await getAereosAllClaveViaje({ ClaveViaje: claveViaje, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_AEREOS_REGISTROS_PAGINA,
            payload: {
                aereos: Response.listGrupoAereo,
                total: Response.tamanio,
                registroPagina: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerAereosPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { registroPagina, claveViaje } = getSate().aereos
    return await getAereosAllClaveViaje({ ClaveViaje: claveViaje, Pagina: Pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_AEREOS_PAGINA,
            payload: {
                aereos: Response.listGrupoAereo,
                total: Response.tamanio,
                pagina: Pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerAereosClaveViajeAction = ({ claveViaje }) => async (dispatch, getSate) => {
    return await getAereosAllClaveViaje({ ClaveViaje: claveViaje, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registroPagina }).then(Response => {
        dispatch({
            type: GET_AEREOS_CLAVE_VIAJE,
            payload: {
                aereos: Response.listGrupoAereo,
                total: Response.tamanio,
                claveViaje: claveViaje,
                pagina: dataInicial.pagina,
                registroPagina: dataInicial.registroPagina
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const clearState = () => (dispatch) => {
    dispatch({
        type: CLEAR_AEREOS_STATE,
        payload: {
            dataInicial,
        },
    });
}